import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogRequestAccessCodeComponent } from './dialog-request-access-code';

@Injectable()
export class DialogService {
  private readonly dialog = inject(MatDialog);

  get host() {
    return this.dialog; 
  }

  showRequestAccessForm(contactNumber: string) {
    return this.dialog.open(DialogRequestAccessCodeComponent, {
      disableClose: true,
      data: { contactNumber },
      width: '80%', // Aumentado significativamente el ancho
      maxWidth: '900px', // Aumentado el ancho máximo para permitir más espacio
    });
  }

  showTerms(termsUrl: string) {
    window.open(termsUrl, '_blank');
  }

  showPrivacyPolicy(privacyUrl: string) {
    window.open(privacyUrl, '_blank');
  }
}
